










































import Vue from 'vue'
import Component from 'vue-class-component'
// import { BIconPersonFill } from 'bootstrap-vue'

export interface link {
  name: string
  url: string
  icon?: string,
  target: string
}

@Component<PageContent>({
  props: {
    title: String,
    description: String,
    linksTitle: String,
    links: Array,
    cvLinkText: String,
    cvLinkUrl: String,
    applicationLinkText: String,
    applicationLinkUrl: String,
    profileLinkText: String,
    profileLinkUrl: String
  }
})

export default class PageContent extends Vue {
  /**
   * Props variables
   */
    title: string | undefined
    description: string | undefined
    linksTitle: string | undefined
    links: link[] | undefined
    cvLinkText: string | undefined
    cvLinkUrl: string | undefined
    applicationLinkText: string | undefined
    applicationLinkUrl: string | undefined
    profileLinkText: string | undefined
    profileLinkUrl: string | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
